import React from "react";
import DialogTitle from "@mui/material/DialogTitle";
import DialogContent from "@mui/material/DialogContent";
import DialogContentText from "@mui/material/DialogContentText";
import DialogActions from "@mui/material/DialogActions";
import Button from "@mui/material/Button";

interface SaveModalBodyProps {
    handleSaveProjectWithoutAuth: (isRewriteProject?: boolean) => void;
    handleSaveWithAuth: () => void;
}
export const SaveModalBody = (props: SaveModalBodyProps) => {
    const { handleSaveProjectWithoutAuth, handleSaveWithAuth } = props;
    return (
        <>
            <DialogTitle>{"Вы не авторизованы на сайте"}</DialogTitle>
            <DialogContent>
                <DialogContentText>
                    Авторизуйтесь на сайте, чтобы проект был привязан к Вашему пользователю. Или можете сохранить без
                    авторизации и получить доступ по ссылке.
                </DialogContentText>
            </DialogContent>
            <DialogActions sx={{ pl: 3, pr: 3, pb: 2 }}>
                <Button variant={"outlined"} onClick={() => handleSaveProjectWithoutAuth()}>
                    Сохранить без авторизации
                </Button>
                <Button variant={"contained"} onClick={handleSaveWithAuth}>
                    Авторизоваться и сохранить
                </Button>
            </DialogActions>
        </>
    );
};
